'use client';

import React, { useEffect, useState, useRef } from 'react';
import styles from './scss/segmentation.module.scss';
import BootstrapTable from 'react-bootstrap-table-next';
import { churnPlotLycaNlpData } from '../../apiservice/aiLycaPilot';

const TypingText = ({
  text,
  onDone,
  speed = 30
}: {
  text: string;
  onDone?: () => void;
  speed?: number;
}) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    let i = 0;
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, i + 1));
      i++;
      if (i === text.length) {
        clearInterval(interval);
        onDone?.();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onDone]);
  return <span dangerouslySetInnerHTML={{ __html: displayedText }} />;

  // return <>{displayedText}</>;

};

const sections = [
  {
    title: 'Proactive actions like personalized offers',
    desc: `The churn prediction model indicates that 14.2% of users are at high risk of leaving, with key contributing factors including a 27% drop in recent usage, unresolved customer complaints, and low engagement with ongoing campaigns.\n\n14.2% of users are predicted to be at high risk of churn.\nThe average usage drop among these users is 27% in the last 30 days.\nCommon churn indicators include reduced app activity, unresolved complaints, and low response to campaigns.\nMost at-risk users are on basic or price-sensitive plans.\nProactive actions like personalized offers and re-engagement campaigns are recommended.`
  },
  {
    title: 'Customer Retention Insights',
    desc: `Medium-risk customers show early warning signs like lower app logins and fewer transactions.\n\nTargeted education and loyalty programs can reduce the risk before it escalates.`
  },
  {
    title: 'Next Steps',
    desc: `Focus on:\n1. Sending personalized offers to high-risk users.\n2. Increasing engagement with loyalty campaigns.\n3. Monitoring early churn signals to adjust strategy.`
  }
];

const Churn3 = ({ onComplete }: { onComplete?: () => void }) => {
  const [visibleSection, setVisibleSection] = useState(0);
  const [phase, setPhase] = useState<'title' | 'desc'>('title');
  const [finishedSections, setFinishedSections] = useState<number[]>([]);
  const chartRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    chartRefs.current[visibleSection]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [visibleSection]);

  const [nlpData, setNlpData] = useState<any | null>(null);

  useEffect(() => {
    const fetchNlpData = async () => {
      try {
        const res = await churnPlotLycaNlpData();
        if (res?.status === 200) {
          setNlpData(res.data.message); // store API result
        }
      } catch (error) {
        console.error('Error fetching NLP data:', error);
      }
    };
    fetchNlpData();
  }, []);

  const handleDone = () => {
    if (phase === 'title') {
      setPhase('desc');
    } else if (phase === 'desc') {
      setFinishedSections((prev) => [...prev, visibleSection]);
      if (visibleSection < sections.length - 1) {
        setVisibleSection((prev) => prev + 1);
        setPhase('title');
      } else {
        onComplete?.();
      }
    }
  };

  return (
    <>


      {/* AI Summary */}
      <div className={styles.aisummarysec} style={{ maxHeight: '622px' }}>
        <div className={styles.aisummarywrapsec}>
          <h4 className={styles.aisumheading}>AI Summary</h4>

          {/* {sections.map((section, i) => {
            if (i > visibleSection) return null;
            const isCurrent = i === visibleSection;
            const isFinished = finishedSections.includes(i);

            return (
              <div
                key={i}
                className={styles.valuecusnew}
                ref={(el) => (chartRefs.current[i] = el)}
              >
                <h4 className={styles.aisumheading}>
                  {isCurrent && phase === 'title' && !isFinished ? (
                    <TypingText
                      key={`title-${i}`} // 🔑 ensures remount
                      text={section.title}
                      onDone={handleDone}
                    />
                  ) : (
                    section.title
                  )}
                </h4>
                <p
                  className={styles.aisumdesc}
                  style={{ lineHeight: "24px", whiteSpace: "pre-line" }}
                >
                  {isCurrent && phase === 'desc' && !isFinished ? (
                    <TypingText
                      key={`desc-${i}`} // 🔑 ensures remount
                      text={section.desc}
                      onDone={handleDone}
                    />
                  ) : (
                    section.desc
                  )}
                </p>
              </div>
            );
          })} */}

          {nlpData && (
            <div className={styles.aisummarytxt}>
              <TypingText text={nlpData[0]?.actual_summary} onDone={onComplete} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Churn3;
